<div
	class="vehicles-swiper swiper"
	#swiperContainer
>
	<div class="swiper-wrapper">
		@for (vehicle of vehicles; track vehicle.idVehicle) {
			<div class="swiper-slide vehicle-card d-flex flex-column text-center position-relative bg-white ck-shadow rounded-3 my-1 me-4">
				@if (utils.isEmpty(vehicle.appraisalCode)) {
					<img
						class="object-fit-cover rounded-4 p-2"
						loading="lazy"
						[src]="utils.isNullOrUndefined(vehicle.idPrincipalPhoto) ? wcmService.noPhotoUrl : utils.getImageUrl(vehicle.idPrincipalPhoto)"
					/>
				} @else {
					<img
						class="object-fit-cover rounded-4 p-2"
						loading="lazy"
						src="{{ vehicle.imageUrl || wcmService.noPhotoUrl }}"
						alt="{{ vehicle.brand + ' ' + vehicle.model }}"
					/>
				}
				<div
					class="text-blue text-truncate p-2 fw-bold"
					[title]="vehicle.brand + ' ' + vehicle.model"
				>
					{{ vehicle.brand }} {{ vehicle.model }}
				</div>
			</div>
		}
	</div>

	<button
		class="swiper-button-prev position-absolute top-50 bg-white start-0"
		#prevBtn
		type="button"
		(click)="onPrev()"
		aria-label="Previous slide"
	></button>
	<button
		class="swiper-button-next position-absolute top-50 translate-middle-y bg-white end-0"
		#nextBtn
		type="button"
		(click)="onNext()"
		aria-label="Next slide"
	></button>
</div>
